// React componet to render a location contact info

import React from 'react';
import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import StringUtils from '../../../../utils/stringUtils';

import { useMediaQuery, Theme } from '@mui/material';
import { StopData } from '../../../../redux/api/load/load.model';
import { TripStop } from '../../../../redux/api/trips/trips.model';

export interface LocationContactInfoProps {
  /**
   * stop
   * */
  stop?: TripStop | null;
}

const LocationContactInfo: React.FC<LocationContactInfoProps> = ({ stop }): JSX.Element => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  if (
    !location ||
    (!stop?.contact?.contact_name &&
      !stop?.contact?.contact_email &&
      !stop?.contact?.contact_number)
  )
    return <></>;

  return (
    <Stack
      direction="column"
      spacing={0}
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{ width: '100%' }}
    >
      <Typography variant="subtitle2" fontWeight="600" color="#6B7280" fontSize="14px">
        Contact:
      </Typography>

      <Typography variant="subtitle2" fontWeight="400" color="#1F2937" fontSize="14px">
        {stop?.contact.contact_name}
      </Typography>

      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={1}
        justifyContent="flex-start"
        alignItems={isMobile ? 'flex-start' : 'center'}
        sx={{ width: '100%' }}
      >
        {stop?.contact.contact_number && (
          <Typography variant="subtitle2" fontWeight="400" fontSize="14px">
            <a
              href={`tel:${stop?.contact.contact_number}${
                stop?.contact?.contact_number_ext ? `;${stop?.contact?.contact_number_ext}` : ''
              }`}
              style={{ color: '#3A4DE9', textDecoration: 'none' }}
            >
              {StringUtils.formatPhoneNumber(
                stop?.contact?.contact_number,
                stop?.contact?.contact_number_ext
              )}
            </a>
          </Typography>
        )}
        {!isMobile &&
          stop?.contact?.contact_number &&
          stop?.contact?.contact_number &&
          stop?.contact?.contact_email && (
            <Typography variant="subtitle2" fontWeight="400" color="#3A4DE9" fontSize="14px">
              •
            </Typography>
          )}
        <Typography variant="subtitle2" fontWeight="400" fontSize="14px">
          <a
            href={`mailto:${stop?.contact?.contact_email}`}
            style={{ color: '#3A4DE9', textDecoration: 'none' }}
          >
            {stop?.contact?.contact_email}
          </a>
        </Typography>
      </Stack>
    </Stack>
  );
};

export default LocationContactInfo;
